// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;

  width: 100vw;
  height: 100vh;
  min-width: 540px;
  min-height: 500px;
  position: relative;
  box-sizing: border-box;
}

.treeview-data-source {
  text-align: left;
  overflow-y: auto;
  height: 510px;
}

.treeview-data-source::-webkit-scrollbar {
  width: 6px;
}

.treeview-data-source::-webkit-scrollbar-thumb {
  background-color: #a6a5a5;
  border-radius: 20px;
}

.treeview-data-source::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.treeview-data-source::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
}

.btn-data-source {
  position: fixed;
  top: 125px;
  left: 44%;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 0px;
  background: #2895eb;
  padding: 7px 25px 8px 33px;
}

/* Ensure text wraps on smaller screens */
.btn-data-source-label {
  position: fixed;
  top: 100px;
  left: 18%;
  border: none;
  color: #2895eb;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 25px 8px 33px;

 
}
.search-option-radios-label{
  position: fixed;
  top: 130px;
  left: 18%;
  border: none;
  color: #2895eb;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 25px 8px 33px;

}
.search-option-radios{
position: fixed;
top:180px;
left:20%;  
}
.search-options-header{
  background-color: rgb(240, 244, 248);
  padding: 15px;
  border-bottom: 1px solid rgb(224, 224, 224);
  margin-bottom: 20px;
  position: fixed;
  top: 100px;
  left: 18%;
  width: 100%;
  height: 150px;
  
}

/* On larger screens, keep the same position */
@media (max-width: 1700px) {
  .btn-data-source-label {
    left: 26%;
     /* Allow text wrapping */
  white-space: normal;
  max-width: 300px; /* Adjust as needed for better wrapping */
  text-align: start; /* Center align the text */
  }

  .btn-data-source {
    left: 50%;

  }
  .search-option-radios-label{
    top:160px;
    left: 26%;
  }
  .search-option-radios{
    top:200px;
  left:27%;  
  }
  .search-options-header{
    left:22.5%;
  }
}

.text-end {
  display: flex;
  justify-content: flex-end;
  color: rgba(128, 128, 128, 0.63);
  font-size: 12px;
  width: 100%;
}

.btn-toggle-header{
  cursor: pointer;
  color: white;
  background-color: #2895eb;
  /* border-radius: 10px; */
  border: none;
  display: flex
;
  justify-content: center;
  align-items: center;
  height:40px;
  width: 40px;
}

.btn-search-options {
  position: fixed;
  top: 140px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
  background: #2895eb;
  padding: 7px 25px 8px 33px;
}

.btn-model-options {
  position: fixed;
  top: 180px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
  background: #2895eb;
  padding: 7px 25px 8px 33px;
}


.btn-specific-search {
  position: fixed;
  top: 220px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
  background: #2895eb;
  padding: 7px 25px 8px 33px;
}

.btn-legal-info {
  position: fixed;
  top: 260px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
  background: #2895eb;
  padding: 7px 25px 8px 33px;
}

.container-box {
  display: flex;
  box-sizing: border-box;
  padding-top: 100px;
  width: 100%;
  height: 100%;
}

.btn-btn-grey {
  position: fixed;
  top: 100px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
  background: grey;
  padding: 7px 25px 8px 33px;
}

.btn-btn-grey-specific {
  position: fixed;
  top: 220px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
  background: grey;
  padding: 7px 25px 8px 33px;
}

.btn-btn-grey-legal {

  position: fixed;
  top: 260px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
  background: grey;
  padding: 7px 25px 8px 33px;
}

.btn-btn-scratch-pad {

  position: fixed;
  top: 180px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 0px;
  background: #2895eb;
  padding: 7px 25px 8px 33px;
}

.btn-btn-reverse {

  position: fixed;
  top: 180px;
  right: 0;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0px 0px 0px 10px;
  background: #2895eb;
  padding: 7px 25px 8px 33px;
}

.btn-btn-research {

  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 10px;
  background: #2895eb;
  padding: 1rem;
}

a {
  text-decoration: none;
}

.box-btns {
  padding-left: 10px;
  padding-right: 10px;
}

.reverse-container .MuiInput-root {
  width: 90%;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  border-radius: 40px;
  /* width: 100%; */
  margin: auto;
  justify-content: center;
  margin-top: 1rem;
}

.reverse-container .MuiInput-root::before {
  border: none;
}

.reverse-container .MuiInput-root::after {
  border: none;
}

.reverse-container .MuiInput-root::after:hover {
  border: none;
}

.reverse-container .MuiInput-root::before:hover {
  border: none;
}

.reverse-container .MuiInput-root:hover {
  border: none;
}

.reverse-container .MuiInput-root input {
  padding: 1rem;
}

.css-bz5ng3-MuiInputBase-root-MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before {
  border: none !important;
}
/* .custom-scrollbar{
  overflow-x: hidden;
} */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;;EAEtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;;;AAG5B;AACA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;;AAE5B;AACA;AACA,eAAe;AACf,SAAS;AACT,QAAQ;AACR;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;;AAEf;;AAEA,8CAA8C;AAC9C;EACE;IACE,SAAS;KACR,wBAAwB;EAC3B,mBAAmB;EACnB,gBAAgB,EAAE,yCAAyC;EAC3D,iBAAiB,EAAE,0BAA0B;EAC7C;;EAEA;IACE,SAAS;;EAEX;EACA;IACE,SAAS;IACT,SAAS;EACX;EACA;IACE,SAAS;EACX,QAAQ;EACR;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ;AACF;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;;AAGA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,0BAA0B;EAE1B,6DAA6D;EAC7D,kBAAkB;EAClB,yHAAyH;EAIzH,aAAa;EAIb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;;GAEG;AACH;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n\n  width: 100vw;\n  height: 100vh;\n  min-width: 540px;\n  min-height: 500px;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.treeview-data-source {\n  text-align: left;\n  overflow-y: auto;\n  height: 510px;\n}\n\n.treeview-data-source::-webkit-scrollbar {\n  width: 6px;\n}\n\n.treeview-data-source::-webkit-scrollbar-thumb {\n  background-color: #a6a5a5;\n  border-radius: 20px;\n}\n\n.treeview-data-source::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n.treeview-data-source::-webkit-scrollbar-corner {\n  background-color: #f1f1f1;\n}\n\n.btn-data-source {\n  position: fixed;\n  top: 125px;\n  left: 44%;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 0px;\n  background: #2895eb;\n  padding: 7px 25px 8px 33px;\n}\n\n/* Ensure text wraps on smaller screens */\n.btn-data-source-label {\n  position: fixed;\n  top: 100px;\n  left: 18%;\n  border: none;\n  color: #2895eb;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 7px 25px 8px 33px;\n\n \n}\n.search-option-radios-label{\n  position: fixed;\n  top: 130px;\n  left: 18%;\n  border: none;\n  color: #2895eb;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 7px 25px 8px 33px;\n\n}\n.search-option-radios{\nposition: fixed;\ntop:180px;\nleft:20%;  \n}\n.search-options-header{\n  background-color: rgb(240, 244, 248);\n  padding: 15px;\n  border-bottom: 1px solid rgb(224, 224, 224);\n  margin-bottom: 20px;\n  position: fixed;\n  top: 100px;\n  left: 18%;\n  width: 100%;\n  height: 150px;\n  \n}\n\n/* On larger screens, keep the same position */\n@media (max-width: 1700px) {\n  .btn-data-source-label {\n    left: 26%;\n     /* Allow text wrapping */\n  white-space: normal;\n  max-width: 300px; /* Adjust as needed for better wrapping */\n  text-align: start; /* Center align the text */\n  }\n\n  .btn-data-source {\n    left: 50%;\n\n  }\n  .search-option-radios-label{\n    top:160px;\n    left: 26%;\n  }\n  .search-option-radios{\n    top:200px;\n  left:27%;  \n  }\n  .search-options-header{\n    left:22.5%;\n  }\n}\n\n.text-end {\n  display: flex;\n  justify-content: flex-end;\n  color: rgba(128, 128, 128, 0.63);\n  font-size: 12px;\n  width: 100%;\n}\n\n.btn-toggle-header{\n  cursor: pointer;\n  color: white;\n  background-color: #2895eb;\n  /* border-radius: 10px; */\n  border: none;\n  display: flex\n;\n  justify-content: center;\n  align-items: center;\n  height:40px;\n  width: 40px;\n}\n\n.btn-search-options {\n  position: fixed;\n  top: 140px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 10px;\n  background: #2895eb;\n  padding: 7px 25px 8px 33px;\n}\n\n.btn-model-options {\n  position: fixed;\n  top: 180px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 10px;\n  background: #2895eb;\n  padding: 7px 25px 8px 33px;\n}\n\n\n.btn-specific-search {\n  position: fixed;\n  top: 220px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 10px;\n  background: #2895eb;\n  padding: 7px 25px 8px 33px;\n}\n\n.btn-legal-info {\n  position: fixed;\n  top: 260px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 10px;\n  background: #2895eb;\n  padding: 7px 25px 8px 33px;\n}\n\n.container-box {\n  display: flex;\n  box-sizing: border-box;\n  padding-top: 100px;\n  width: 100%;\n  height: 100%;\n}\n\n.btn-btn-grey {\n  position: fixed;\n  top: 100px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 10px;\n  background: grey;\n  padding: 7px 25px 8px 33px;\n}\n\n.btn-btn-grey-specific {\n  position: fixed;\n  top: 220px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 10px;\n  background: grey;\n  padding: 7px 25px 8px 33px;\n}\n\n.btn-btn-grey-legal {\n\n  position: fixed;\n  top: 260px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 10px;\n  background: grey;\n  padding: 7px 25px 8px 33px;\n}\n\n.btn-btn-scratch-pad {\n\n  position: fixed;\n  top: 180px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 0px;\n  background: #2895eb;\n  padding: 7px 25px 8px 33px;\n}\n\n.btn-btn-reverse {\n\n  position: fixed;\n  top: 180px;\n  right: 0;\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0px 0px 0px 10px;\n  background: #2895eb;\n  padding: 7px 25px 8px 33px;\n}\n\n.btn-btn-research {\n\n  border: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 10px;\n  background: #2895eb;\n  padding: 1rem;\n}\n\na {\n  text-decoration: none;\n}\n\n.box-btns {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.reverse-container .MuiInput-root {\n  width: 90%;\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.87);\n  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  border-radius: 4px;\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 40px;\n  /* width: 100%; */\n  margin: auto;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.reverse-container .MuiInput-root::before {\n  border: none;\n}\n\n.reverse-container .MuiInput-root::after {\n  border: none;\n}\n\n.reverse-container .MuiInput-root::after:hover {\n  border: none;\n}\n\n.reverse-container .MuiInput-root::before:hover {\n  border: none;\n}\n\n.reverse-container .MuiInput-root:hover {\n  border: none;\n}\n\n.reverse-container .MuiInput-root input {\n  padding: 1rem;\n}\n\n.css-bz5ng3-MuiInputBase-root-MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before {\n  border: none !important;\n}\n/* .custom-scrollbar{\n  overflow-x: hidden;\n} */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 8px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
